import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { players } from '../../data/players';
import PlayerCard from './PlayerCard';

const PlayerShopSection = () => {
  const railRef = useRef(null);
  const visiblePlayers = players.filter((player) => player.image);

  const moveRail = (direction) => {
    railRef.current?.scrollBy({ left: direction * railRef.current.clientWidth * 0.92, behavior: 'smooth' });
  };

  return (
  <section id="player-shop-title" className="cab-player-shop" aria-labelledby="player-shop-heading">
    <div className="cab-player-shop__grid" aria-hidden="true" />
    <div className="cab-container">
      <div className="cab-player-shop__header">
        <motion.div initial={{ opacity: 0, y: 22 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.25 }} transition={{ duration: 0.6 }}>
          <div className="cab-player-shop__eyebrow"><span /> SHOP BY PLAYER</div>
          <h2 id="player-shop-heading">WEAR YOUR PLAYER.<br /><strong>REPRESENT YOUR CLUB.</strong></h2>
          <p>Discover the CAB collection through the players who wear the badge.</p>
        </motion.div>
        <Link to={`/players/${visiblePlayers[0].id}`} className="cab-player-shop__all">View all players <ArrowRight size={17} /></Link>
      </div>

      <div className="cab-player-shop__carousel">
        <button type="button" className="cab-player-shop__control cab-player-shop__control--previous" onClick={() => moveRail(-1)} aria-label="Joueurs précédents"><ArrowLeft size={18} /></button>
        <div ref={railRef} className="cab-player-shop__rail">
          {visiblePlayers.map((player, index) => <PlayerCard key={player.id} player={player} index={index} />)}
        </div>
        <button type="button" className="cab-player-shop__control cab-player-shop__control--next" onClick={() => moveRail(1)} aria-label="Joueurs suivants"><ArrowRight size={18} /></button>
      </div>
      <div className="cab-player-shop__foot"><span>THE CAB SQUAD / 2026—27</span><span>{String(players.length).padStart(2, '0')} PLAYERS <i /></span></div>
    </div>
  </section>
  );
};

export default React.memo(PlayerShopSection);
